import DownloadTemplateCard from "../-components/-upload-file/DownloadTemplateCard";
import UploadFileDropZoneCard from "../-components/-upload-file/UploadFileDropZoneCard";
import type { ExportApiUrl } from "../types";

type Props = {
  setUploadedFileKey: (key: string | undefined) => void;
  exportApiUrl: ExportApiUrl;
  exportFilename: string;
  templateMessage: {
    templateTitle: string;
    updateExisting: string;
  };
};

const UploadFile = ({
  setUploadedFileKey,
  exportApiUrl,
  exportFilename,
  templateMessage,
}: Props) => (
  <>
    <DownloadTemplateCard
      exportApiUrl={exportApiUrl}
      exportFilename={exportFilename}
      templateMessage={templateMessage}
    />
    <UploadFileDropZoneCard setUploadedFileKey={setUploadedFileKey} />
  </>
);

export default UploadFile;
